<template>
  <div>
    <van-popup v-model="showpPopup" :overlay-style="{ background: 'rgba(0,0,0,.7)' }">
      <div class="content-container">
        <div class="title">填写邮寄信息</div>
        <div class="content">
          <div class="form">
            <div class="form-content">
              <input type="text" @input="changeInputVal('userNameKms')" v-model.trim="infoData.userName" placeholder="收件人" class="input" />
            </div>

            <div class="form-content">
              <input type="number" @input="changeInputVal('mobileKms')" v-model.trim="infoData.mobile" placeholder="联系电话" class="input" />
            </div>

            <div class="form-content">
              <van-field
                @input="changeInputVal('addressKms')"
                v-model="infoData.address"
                rows="3"
                autosize
                type="textarea"
                placeholder="收货地址"
                class="address"
              />
            </div>

            <div class="btn" @click="submit">提交</div>
          </div>
        </div>
        <img class="close" @click="showpPopup = false" src="@/static/images/activityCenter/202404/01/close.png" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      showpPopup: false,
      infoData: {}
    };
  },

  methods: {
    open() {
      this.getDetail();
    },

    getDetail() {
      this.loading = true;
      this.$http({
        url: '/api/okbAct/actEntityLog/queryEntityLog',
        type: 'GET',
        hideAlert: true,
        data: {}
      }).then(res => {
        if (res.httpCode != 1) {
          this.loading = false;
          this.$notice.msg(res.msg);
          return;
        }
        this.infoData = res.data;
        this.showpPopup = true;
        this.loading = false;
      });
    },

    // 清空加密
    changeInputVal(keyKms) {
      this.infoData[keyKms] = '';
    },

    submit() {
      if (!this.infoData.userName) {
        this.$notice.msg('请输入收件人');
        return;
      }
      if (!this.infoData.mobile) {
        this.$notice.msg('请输入联系电话');
        return;
      }
      if (!this.infoData.mobileKms) {
        let regExp = /^1[3456789]\d{9}$/;
        if (!regExp.test(this.infoData.mobile)) {
          this.$notice.msg('联系电话格式不正确');
          return;
        }
      }
      if (!this.infoData.address) {
        this.$notice.msg('请输入收货地址');
        return;
      }
      this.$http({
        url: '/api/okbAct/actEntityLog/withdrawEntity',
        type: 'POST',
        hideAlert: true,
        data: {
          userName: this.infoData.userName.replace(/\s*/g, ''),
          userNameKms: this.infoData.userNameKms,
          mobile: this.infoData.mobile.replace(/\s*/g, ''),
          mobileKms: this.infoData.mobileKms,
          address: this.infoData.address.replace(/\s*/g, ''),
          addressKms: this.infoData.addressKms
        }
      }).then(res => {
        if (res.httpCode != 1) {
          this.$notice.msg(res.msg);
          return;
        }
        this.showpPopup = false;
        this.$notice.msg('提交成功');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  background: transparent !important;
  padding-bottom: 120px;
}
.content-container {
  position: relative;
  padding: 30px 15px 15px 15px;
  background: linear-gradient(44deg, #ef3805 0%, #ffab3b 100%);
  border-radius: 45px;
  border: 2px solid #ffd93e;
  width: 660px;
  .title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 36px;
    color: #fff;
    font-weight: bold;
    letter-spacing: 2px;
  }
  .content {
    padding: 40px 0px 46px 0px;
    background: linear-gradient(37deg, #fff5e2 0%, #ffffff 100%);
    box-shadow: 0px 0px 14px #de4700;
    border-radius: 36px;
    border: 3px solid #ffd195;
    .form {
      display: flex;
      flex-direction: column;
      width: 570px;
      margin: 0 auto;
      .form-content {
        margin-bottom: 20px;
        .input {
          width: 570px;
          height: 90px;
          border: 1px solid #ffc47b;
          border-radius: 10px;
          padding-left: 30px;
          font-size: 30px;
          color: #333333;
          letter-spacing: 1px;
        }
        .address {
          width: 570px;
          height: 212px;
          border: 1px solid #ffc47b;
          border-radius: 10px;
          padding-left: 30px;
          font-size: 30px;
          color: #333333;
          letter-spacing: 1px;
        }
      }
    }
  }
  .btn {
    width: 578px;
    height: 100px;
    background-image: url('~@/static/images/activityCenter/202404/01/btn-bg.png');
    background-size: 100% 100px;
    margin: 0 auto;
    background-repeat: no-repeat;
    font-size: 34px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    letter-spacing: 2px;
  }
  .close {
    position: absolute;
    width: 66px;
    height: 66px;
    bottom: -120px;
    left: 50%;
    margin-left: -33px;
  }
}
/deep/.van-field__control::-webkit-input-placeholder {
  color: #9b9b9b;
  font-size: 30px;
}
input::input-placeholder {
  color: #9b9b9b;
  font-size: 30px;
}
input::-webkit-input-placeholder {
  color: #9b9b9b;
  font-size: 30px;
}

input::-moz-placeholder {
  color: #9b9b9b;
  font-size: 30px;
}
</style>
